function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipRule: "evenodd",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "m43.4 19c.4-1.4-1.5-4-2.6-5.2l2.7-2.7c.5.5 4.6 4.9 3.6 9zm-15.8 21.2 1.3-.3-1-3.7s-4.2 1.2-6.9-1.4l-2.6 2.8c3.1 3 7 2.9 9.2 2.6",
  fill: "#f96f31"
}), React.createElement("path", {
  d: "m29.5 1.3c-4.3.7-7.3-1.3-7.3-1.3s1.4 3.4-.2 7.5c4.2-.8 7.2 1.3 7.2 1.3s-1.4-3.4.3-7.5",
  fill: "#6ebbeb"
}), React.createElement("path", {
  d: "m7.8 28.5c-4.3.8-7.3-1.3-7.3-1.3s1.5 3.4-.2 7.5c4.2-.8 7.2 1.3 7.2 1.3s-1.4-3.4.3-7.5",
  fill: "#d262a9"
}), React.createElement("path", {
  d: "m30 26.5c-2-.7-2.5-2.4-3-3.6-.3-1.1-.5-1.5-1-1.7-.4-.1-.8 0-1.7.8-1 .8-2.4 1.9-4.3 1.2-2-.6-2.5-2.3-2.9-3.5-.3-1.2-.5-1.5-1-1.7-.4-.1-.8 0-1.7.8-1 .8-2.4 1.9-4.3 1.2-2-.6-2.5-2.3-2.9-3.5-.3-1.2-.5-1.5-1-1.7l.9-2.7c1.9.6 2.4 2.3 2.8 3.6.4 1.1.5 1.5 1 1.6.5.2.8 0 1.8-.7 1-.8 2.3-1.9 4.3-1.3s2.4 2.3 2.8 3.6c.4 1.1.5 1.5 1 1.6.5.2.8 0 1.8-.7 1-.8 2.4-1.9 4.3-1.3 2 .7 2.5 2.3 2.8 3.6.4 1.1.6 1.5 1 1.6l-.8 2.8z",
  fill: "#59b4a6"
}), React.createElement("path", {
  d: "m3.5 47.1-3.5-1.4c0-.2 2-5 8.3-5.8l.5 3.8c-4 .6-5.2 3.3-5.3 3.4",
  fill: "#6ebbeb"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: 48,
    height: 48
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/confetti.418a0d69.svg";
export { SvgComponent as ReactComponent };